import { type ColorPalette } from '../colors';

/**
 * Applies CSS custom properties to the document root element.
 * This allows CSS files to use theme-controlled variables that automatically
 * update when the theme changes.
 */
export const applyCssVariables = (colors: ColorPalette): void => {
  if (typeof document === 'undefined') {
    // Skip in SSR/testing environments
    return;
  }

  const root = document.documentElement;

  // Apply all CSS variables from the theme
  Object.entries(colors.cssVariables).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
};

/**
 * Removes theme-controlled CSS variables from the document root.
 * Useful for cleanup or reset scenarios.
 */
export const removeCssVariables = (colors: ColorPalette): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const root = document.documentElement;

  Object.keys(colors.cssVariables).forEach((property) => {
    root.style.removeProperty(property);
  });
};
